export default {
  namespaced: true,
  actions: {
    create({ commit }, affiliation) {
      return Vue.$http.post('candidate/affiliations', { affiliation })
    },
    destroy({ commit }, id) {
      return Vue.$http.delete(`candidate/affiliations/${id}`)
    }
  }
}
